import { Grid } from '@/hen-ui/composites/Grid';

import { CareerExplorerStatisticCard } from './CareerExplorerStatisticCard';
import type { CareerExplorerStatistic } from './types';

interface CareerExplorerStatisticListProps {
  statistics: CareerExplorerStatistic[];
}

export const CareerExplorerStatisticList = ({
  statistics,
}: CareerExplorerStatisticListProps) => {
  if (statistics.length === 0) {
    return null;
  }

  return (
    <Grid columns={2} columns-md={3} gap='xs' className='md:gap-sm'>
      {statistics.map((statistic) => (
        <CareerExplorerStatisticCard key={statistic.id} {...statistic} />
      ))}
    </Grid>
  );
};
